"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnSetGrid = exports.PagingGrid = exports.Grid = exports.QueryResults = exports.Memory = exports.domConstruct = exports.Deferred = void 0;
__exportStar(require("./__package__"), exports);
//  dojo  ---
// import "dojo/has!webpack?dojo-webpack-plugin/amd/dojoES6Promise";
var declare = require("dojo/_base/declare");
var _Deferred = require("dojo/Deferred");
var _domConstruct = require("dojo/dom-construct");
exports.Deferred = _Deferred;
exports.domConstruct = _domConstruct;
//  dstore  ---
var _Memory = require("dojo-dstore/Memory");
var _QueryResults = require("dojo-dstore/QueryResults");
exports.Memory = _Memory;
exports.QueryResults = _QueryResults;
//  dgrid  ---
var _Grid = require("dgrid/Grid");
// import * as List from "dgrid/List";
var OnDemandGrid = require("dgrid/OnDemandGrid");
var Keyboard = require("dgrid/Keyboard");
var Selection = require("dgrid/Selection");
var ColumnSet = require("dgrid/ColumnSet");
var ColumnResizer = require("dgrid/extensions/ColumnResizer");
var CompoundColumns = require("dgrid/extensions/CompoundColumns");
var nlsPagination = require("dgrid/extensions/nls/pagination");
//  Other ---
var gridHelper_1 = require("./gridHelper");
exports.Grid = declare("Grid", [OnDemandGrid, Keyboard, Selection, ColumnResizer, CompoundColumns, gridHelper_1.GridHelper]);
exports.Grid.prototype.i18nPagination = nlsPagination.root;
exports.PagingGrid = declare("PagingGrid", [_Grid, gridHelper_1.Pagination, Keyboard, Selection, ColumnResizer, CompoundColumns, gridHelper_1.GridHelper]);
exports.PagingGrid.prototype.i18nPagination = nlsPagination.root;
exports.ColumnSetGrid = declare("ColumnSetGrid", [OnDemandGrid, ColumnSet, Keyboard, Selection, ColumnResizer, gridHelper_1.GridHelper]);
exports.ColumnSetGrid.prototype.i18nPagination = nlsPagination.root;
//# sourceMappingURL=index.js.map